import { Injectable } from '@angular/core';
import { LocationSelectorService } from '@services/location_selector.service';
import { sharedResolution } from '../../../../src/shared_resolution';
import { SpaContext } from '../../Classes/spacontext';
import { GuiComponentApiModel } from '../api/v2/Models/GuiComponentApiModel';
import { UnitApiService } from '../api/v2/units_api.service';
import { ComponentIdentityButton } from './component_identity_button';
import { ComponentIdentityButtonIcon } from './component_identity_button_icon';
import { ComponentIdentityImage } from './component_identity_image';
import { ComponentIdentityList } from './component_identity_list';
import { ComponentIdentityRockBottom } from './component_identity_rock_bottom';
import { ComponentIdentityText } from './component_identity_text';
import { ComponentUnion, IdentityFactoryService } from './identity_factory.service';

// https://github.com/VisibaCare/public/pull/105

@Injectable()
export class FlexiblePatientButtonsService {
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	public components: any[] = []; // Angular template doesn't work with union idk don't fire me
	// public components: ComponentUnion[] = [];
	public types = {
		componentIdentityButtonIcon: ComponentIdentityButtonIcon,
		componentIdentityButton: ComponentIdentityButton,
		componentIdentityImage: ComponentIdentityImage,
		componentIdentityList: ComponentIdentityList,
		componentIdentityRockBottom: ComponentIdentityRockBottom,
		componentIdentityText: ComponentIdentityText,
	};
	public isLoading = true;

	constructor(
		// biome-ignore lint/correctness/noUnusedPrivateClassMembers: suppressed due to migration - should be fixed
		private readonly spaContext: SpaContext,
		private readonly unitApiService: UnitApiService,
		private readonly identityFactoryService: IdentityFactoryService,
	) {
		// Empty
	}

	public fetchComponents(): void {
		this.isLoading = true;

		const locationSelectorService = sharedResolution.resolve(LocationSelectorService);

		this.unitApiService.getUnitComponents(locationSelectorService.locationUnitId).subscribe(
			({ data }) => {
				this.components = this.parseBackendData(data);
				this.isLoading = false;
			},
			// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
			() => {},
		);
	}

	private parseBackendData(data: GuiComponentApiModel[]): ComponentUnion[] {
		return data
			.sort((a, b) => {
				if (a.Order > b.Order) return 1;
				if (a.Order < b.Order) return -1;

				return 0;
			})
			.map((guiComponent) =>
				this.identityFactoryService.produce(guiComponent.Type, {
					id: guiComponent.Id,
					backendMessage: guiComponent.Data,
				}),
			);
	}
}
